import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal.jsx";

export default function DiscoverySection() {
  return (
    <section
      className="kw-section kw-discovery"
      aria-labelledby="discovery-title"
    >
      <Reveal>
        <span className="kw-small-label">
          YOU KNOW YOUR BUSINESS. LET’S LOOK AT THE POSSIBILITIES.
        </span>
        <h2 id="discovery-title">
          You don’t need to know
          <br />
          what the software should be.
        </h2>
        <p>
          Show us how the work happens today. We ask the right questions,
          understand your business, and identify where software can make the
          biggest difference.
        </p>
        <Link
          to="/contact"
          className="kw-primary-link"
          data-analytics="discovery_contact"
        >
          Let’s talk <ArrowUpRight size={17} />
        </Link>
      </Reveal>
      <Reveal className="kw-discovery-conversation" delay={100}>
        <span className="kw-small-label">
          A CONVERSATION, THEN A CLEARER PICTURE
        </span>
        <ol>
          <li>
            <strong>Start with what slows you down.</strong>
            <p>
              A short discovery call about your team, systems, and day-to-day
              work.
            </p>
          </li>
          <li>
            <strong>See what’s possible, privately.</strong>
            <p>
              A relevant private walkthrough can show how a portal or
              application works and make the possibilities easier to picture.
            </p>
          </li>
          <li>
            <strong>Keep building as the business evolves.</strong>
            <p>
              Agree on priorities with Karalewich, from development through
              ongoing support and improvements.
            </p>
          </li>
        </ol>
        <span className="kw-discovery-fit">
          For established businesses ready to improve how they work. We
          typically respond within the business day.
        </span>
      </Reveal>
    </section>
  );
}
